var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import {
newEntity as newEntityAction,
showImportPanel as showImportPanelAction } from "../../Uploads/actions/uploadsActions";

import { connect } from 'react-redux';
import { NeedAuthorization } from "../../Auth";
import Export from "./ExportButton";
import { PDFUploadButton } from "./PDFUploadButton";













const LibraryFooterComponent = ({
  storeKey,
  newEntity,
  showImportPanel,
  scrollCount
}) => {
  const [footerVisible, setFooterVisible] = useState(false);
  const toggleFooterVisible = () => {
    setFooterVisible(!footerVisible);
  };
  useEffect(() => {
    if (footerVisible && scrollCount > 0) {
      setFooterVisible(false);
    }
  }, [scrollCount]);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", {
      className: `library-footer with-sidepanel remove-nesting ${!footerVisible ? 'closed' : ''}` }, void 0, /*#__PURE__*/

    _jsx("div", { className: "close-actions-button" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "toggle-footer-button", onClick: toggleFooterVisible }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Hide actions"))), /*#__PURE__*/


    _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "btn btn-default btn-footer-hover-success",
      type: "button",
      onClick: () => newEntity(storeKey) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "plus" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Create entity")))), /*#__PURE__*/



    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx(PDFUploadButton, { storeKey: storeKey })), /*#__PURE__*/

    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("button", { className: "btn btn-default sm-order-1", type: "button", onClick: showImportPanel }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "import-csv", transform: "up-0.2" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Import CSV")))), /*#__PURE__*/



    _jsx(Export, { className: "sm-order-1", storeKey: storeKey }))), /*#__PURE__*/


    _jsx("div", { className: `open-actions-button ${footerVisible ? 'closed' : ''}` }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "toggle-footer-button", onClick: toggleFooterVisible }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Show actions")))));




};

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
  { newEntity: newEntityAction, showImportPanel: showImportPanelAction },
  wrapDispatch(dispatch, props.storeKey));

}

export const LibraryFooter = connect(
null,
mapDispatchToProps)(
LibraryFooterComponent);